import React from "react";
import { defineMessages, FormattedMessage, FormattedNumber } from "react-intl";
import { LANDSCAPE_LAYOUT } from "./constants";
import classnames from "classnames";
import styles from "./PromotionList.scss";

const msgsDiscount = defineMessages({
  discount: {
    id: "app.promotion_list..discount.discount",
    description: "discount",
    defaultMessage: "Discount",
  },
});

/* TODO: PASS CURRENCY ?? */
export default function Discount({ promotion, layout, currency, ...props }) {
  if (promotion.get("reduction") && Math.abs(promotion.get("reduction")) > 0) {
    const discountClasses = {
      "wbkv9-Discount": true,
      [styles.discountContainer]: true,
      [styles.discounted]: layout === LANDSCAPE_LAYOUT,
    };
    return (
      <div className={classnames(discountClasses)} {...props}>
        {!promotion.get("percentage") && (
          <div className={classnames("wbkv9-Discount-discountValue", styles.discountValue)}>
            <div className={styles.currency}>{currency}</div>
            <div className="reduction">
              <FormattedNumber value={promotion.get("reduction")} maximumFractionDigits={2} />
            </div>
          </div>
        )}
        {promotion.get("percentage") && (
          <div className={classnames("wbkv9-Discount-discountValue", styles.discountValue)}>
            <div className="reduction">
              <FormattedNumber value={promotion.get("reduction")} maximumFractionDigits={2} />%
            </div>
          </div>
        )}

        <div className={classnames("wbkv9-Discount-subtext", "subtext")}>
          <div>
            <FormattedMessage {...msgsDiscount.discount} />
          </div>
        </div>
      </div>
    );
  }

  return null;
}
